module.exports = __webpack_public_path__ + "47b256dda3693936ec75446bf01c3d7e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/videos/cnn-richard-prince.jpg
 ** module id = 397
 ** module chunks = 0
 **/